module.exports = __webpack_public_path__ + "img/my.aa653fdd.png";